// extracted by mini-css-extract-plugin
export default {"container":"ReceiverScreen_container__vxLaV"};